<template>
    <div class="cell" type="text" :style="getStyle">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'TableCell',

    computed: {
        getStyle() {
            var str = '';

            if (!this.cell) return;

            if (this.cell.flex > 0) {
                str += 'flex: ' + this.cell.flex + ';';
            }

            if (this.cell.width != '') {
                str += 'width: ' + this.cell.width + ';';
            }

            if (this.cell.hidden) {
                str += 'display: none;';
            }

            if (this.cell.bold) {
                str += 'font-weight: 900;';
            }

            if (this.cell.hidden) {
                str += 'display:none;';
            }

            return str != '' ? str : false;
        },
    },

    props: {
        cell: {
            type: Object,
            required: false,
        },

        text: {
            type: String,
            required: false,
        },
    },

    components: {},
};
</script>

<style lang="less" scoped>
@import '~@variables';

.cell {
    padding: 5px;
    font-size: 11px;

    &:first-child,
    &:nth-child(2) {
        padding-left: 0px;
    }

    &:last-child {
        padding-right: 0px;
    }
}
</style>
